import { TabContentTranslations } from ".";

export const TAB_CONTENT_FR_FR: TabContentTranslations = {
	consolidated: "Consolides",
	extract: "Extrait",
};
